// extracted by mini-css-extract-plugin
export default {"formContainer":"formContainer__wfOBpr"};